export default {
    namespaced: true,
    state: {
        gnStats: [],
        categories: [],
        errors: {
            gnStats: '',
            categories: ''
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        },
        SET_GNSTATS(state, payload) {
            state.gnStats = payload
        },
        SET_CATEGORIES(state, categories) {
            state.categories = categories
        }
    },
    actions: {
        async getGnStats({ commit }) {
            commit('SET_ERRORS', {
                key: 'gnStats',
                val: ''
            })

            const url = '/public/statistics'

            try {
                const resp = await this.$axios.get(url)
                commit('SET_GNSTATS', resp.data)
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'gnStats',
                        val: e.response.data
                    })
                }
            }
        },
        getCategories({ commit }) {
            return this.$axios
                .get('/public/statistics/category')
                .then(({ data }) => {
                    commit('SET_CATEGORIES', data)
                })
                .catch(({ response }) => {
                    console.log(response.data)
                    commit('SET_ERRORS', {
                        key: 'categories',
                        val: response.data
                    })
                })
        }
    }
}
